import * as form from '../form';

export const citizenshipMultiple = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        ForeignPassports: form.collection(form.foreignPassportCollection(xitem.ForeignPassports)),
        Country: form.country(xitem.Country),
        Dates: form.daterange(xitem.Dates),
        How: form.textarea(xitem.How),
        Renounced: form.branch(xitem.Renounced),
        RenouncedExplanation: form.textarea(xitem.RenouncedExplanation),
        Current: form.branch(xitem.Current),
        CurrentExplanation: form.textarea(xitem.CurrentExplanation),
        CurrentComments: form.textarea(xitem.CurrentComments),
        Comments: form.textarea(xitem.Comments),
        EverIssuedPassport: form.branch(xitem.EverIssuedPassport),
        IsPassportActive: form.branch(xitem.IsPassportActive),
      },
    };
  });
  return {
    HasMultiple: form.branch(data.HasMultiple),
    Comments: form.textarea(data.Comments),
    SummaryComments: form.textarea(data.SummaryComments),
    List: form.collection(items, (data.List || {}).branch),
  };
};
